import { dashboardApi } from "src/services/settings/dashboard";
import { CONTENT_MODERATORS, CAPABILITIES, FETCH, UPDATE, ACTIVITY_EVENTS, ACTIVATION } from "../queryKeys";
import { useInfiniteQueryBuilder, useMutationBuilder, useQueryBuilder } from "../useBuilders";
import _ from "lodash";
import userRoleService from "src/utils/userRoles.service";
import { orderCapabilities } from "src/utils/util";

export const useCapabilitiesFetch = () => {
  return useQueryBuilder(
    [CAPABILITIES, FETCH],
    dashboardApi.fetchCapabilities,
    true,
    0,
    true,
    (data) => {
      const filteredData = _.filter(data, (item) => {
        const type = item?.productCapabilityResponse.type;
        if (type != "linkedin_integration") return item;
        return userRoleService.isLinkedinEnabled() && item;
      });
      return orderCapabilities(filteredData);
    })
};


export const useCapabilitiesActionNeededFetch = () => {
  return useQueryBuilder([CAPABILITIES, 'ACTION_NEEDED'], dashboardApi.fetchCapabilitiesActionNeeded);
};

export const useCapabilitiesUpdate = () => {
  return useMutationBuilder([CAPABILITIES, UPDATE], dashboardApi.updateCapabilities, [CAPABILITIES, FETCH]);
}

export const useContentModeratorsFetch = () => {
  return useQueryBuilder([CONTENT_MODERATORS, FETCH], dashboardApi.fetchContentModerators);
};

export const useContentModeratorsUpdate = () => {
  return useMutationBuilder([CONTENT_MODERATORS, UPDATE], dashboardApi.updateContentModerators, [CONTENT_MODERATORS, FETCH]);
};

export const useEventsFetch = () => {
  return useInfiniteQueryBuilder(
    [ACTIVITY_EVENTS],
    ({ pageParam = 0 }) => dashboardApi.fetchEvents(pageParam),
    0,
    (response) => {
      const nextPage = (response?.totalPages > response?.currentPage + 1) ? response?.currentPage + 1 : undefined;
      return nextPage;
    }
  );
};

export const useRecordCapabilityActivation = () => {
  return useMutationBuilder([CAPABILITIES, ACTIVATION], dashboardApi.recordCapabilityActivation);
};